import "./styles.scss"

import React from "react"
import { motion } from "framer-motion"

import { fadeAnimation } from "utils"

const PageHeader = ({ title }) => {
  return (
    <section className="page-header">
      <div className="container">
        <motion.div
          className="page-header__header"
          dangerouslySetInnerHTML={{ __html: parse(title) }}
          {...fadeAnimation}
        />
      </div>
    </section>
  )
}

const parse = string => {
  if (!string) return

  let newString = string

  if (string.indexOf("(") > 0) {
    const position = string.indexOf("(")
    const strings = [
      string.slice(0, position - 1),
      string.slice(position, string.length),
    ]
    const stringsParsed = strings.map((string, index) =>
      index === 0 ? `${string}<br/>` : `<span>${string}</span>`
    )

    newString = stringsParsed.join(" ")
  } else {
    const strings = string.split(" ")
    const stringsParsed = strings.map((string, index) => {
      if (index === 1) {
        return `<span>${string}`
      } else if (index + 1 === strings.length) {
        return `${string}</span>`
      } else {
        return string
      }
    })

    newString = stringsParsed.join(" ")
  }

  return newString
}

export default PageHeader
